// extracted by mini-css-extract-plugin
export default {"emptyBlock":"WfrjAYrnY_upa8l9Omjr","alertImage":"snFpT2WQYGIVQD3vI7Sg","alertImageMobile":"ThJnWUiBoD6xetAOsfOb"};